import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SCROLL_OFFSET = 140;

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    const id = hash.replace("#", "");
    let attempts = 0;
    const maxAttempts = 20;

    const scrollToHash = () => {
      const target = document.getElementById(id);

      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;
        window.scrollTo({ top, behavior: "smooth" });
        return;
      }

      if (attempts < maxAttempts) {
        attempts += 1;
        window.setTimeout(scrollToHash, 60);
      }
    };

    scrollToHash();
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
